import $ from 'jquery';

var apiLoaded = false;
var player = null;
var players = [];
var settings = {
  playerId: '',
  videoId: '',
  videoTxt: ''
};

var Video = {

  init: function () {

    // Video with modals:
    $('body').on('click', '.js-play', function (e) {
      e.preventDefault();
      settings.videoId = $(this).data('video');
      settings.videoModalId = '#' + $(this).data('id');
      $(settings.videoModalId).foundation('open');
    });
    $('body').on('open.zf.reveal', this.launch);
    $('body').on('closed.zf.reveal', this.stopAllVimeoVideos);
  },

  launch: function (e) {
    e.preventDefault();

    settings.videoId = $(e.currentTarget).data('video') || settings.videoId;
    $(settings.videoModalId).find('.responsive-embed').append("<div id='vimeoPlayer'></div>");

    if (!apiLoaded) {
        var tag = document.createElement('script');
        tag.src = 'https://player.vimeo.com/api/player.js';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        tag.addEventListener('load', function(e){
          Video.loadVideo()
        })
    } else {
      Video.loadVideo();
    }
  },

  loadVideo: function () {
    apiLoaded = true;
    var player = new Vimeo.Player('vimeoPlayer', {
      height: '100%',
      width: '100%',
      id: settings.videoId,
      autoplay: true,
      events: {
        'onReady': Video.playVideo
      }
    });
    player.play();
  },

  playVideo: function (event) {
    players.push(player);
  },

  stopAllVimeoVideos: function () {
    for (var i = 0; i < players.length; i++) {
      try {
        players[i].stopVideo();
      } catch (ex) { }
    }

    $('#vimeoPlayer').closest('.responsive-embed').empty();
  },
};

export default Video;
